// frontend/src/features/ups/components/DriverMobileCard.js
import React from 'react';

const toneClasses = {
  default: 'border-app-accent bg-app-primary text-app-accent',
  request: 'border-blue-200 bg-blue-50 text-blue-700',
  banned: 'border-red-200 bg-red-50 text-red-700',
  blocked: 'border-yellow-200 bg-yellow-50 text-yellow-800',
  internal: 'border-blue-200 bg-blue-50 text-blue-700',
};

const isPresent = (value) => value !== null && value !== undefined && value !== '';

export default function DriverMobileCard({
  title,
  subtitle,
  avatarText,
  tone = 'default',
  fields = [],
  badges = [],
  actions = null,
  mutedText,
}) {
  const visibleFields = fields.filter((field) => {
    if (!field) return false;
    const value = Array.isArray(field) ? field[1] : field.value;
    return isPresent(value);
  });

  const visibleBadges = badges.filter(Boolean);
  const initials = (avatarText || title || '-').toString().trim().slice(0, 2).toUpperCase();
  const avatarClass = toneClasses[tone] || toneClasses.default;

  return (
    <article className="rounded-2xl border border-app-border bg-app-card p-4 shadow-sm">
      <div className="flex items-start gap-3">
        <div
          className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-full border text-xs font-bold uppercase ${avatarClass}`}
        >
          {initials || '-'}
        </div>

        <div className="min-w-0 flex-1">
          <div className="truncate font-semibold text-app-text">{title || '-'}</div>
          {subtitle && <div className="mt-1 text-xs text-app-muted">{subtitle}</div>}
          {mutedText && <div className="mt-2 text-sm text-app-muted">{mutedText}</div>}
        </div>
      </div>

      {visibleBadges.length > 0 && (
        <div className="mt-3 flex flex-wrap gap-2">
          {visibleBadges.map((badge, index) => (
            <React.Fragment key={badge?.key || index}>{badge}</React.Fragment>
          ))}
        </div>
      )}

      {visibleFields.length > 0 && (
        <dl className="mt-4 grid grid-cols-1 gap-3 rounded-2xl bg-app-surface p-3">
          {visibleFields.map((field, index) => {
            const label = Array.isArray(field) ? field[0] : field.label;
            const value = Array.isArray(field) ? field[1] : field.value;

            return (
              <div key={`${label || 'field'}-${index}`} className="min-w-0">
                <dt className="text-[11px] font-semibold uppercase tracking-[0.16em] text-app-muted">
                  {label}
                </dt>
                <dd className="mt-1 break-words text-sm font-medium text-app-text">{value}</dd>
              </div>
            );
          })}
        </dl>
      )}

      {actions && <div className="mt-4 flex flex-wrap items-center gap-2">{actions}</div>}
    </article>
  );
}
